<template>
  <div class="ViewDrive">
    <div :class="['content', { 'large-embed': page.large_embed }]">
      <!-- <WavingText
        :text="page.title"
        duration="1.1"
        side="0.25em"
        fromcolor="white"
        tocolor="white"
      ></WavingText> -->
      <div class="header-image-wrapper">
        <img
          src="@/assets/images/website_header_final.png"
          alt="2025 Membership Drive"
          class="header-image"
        />
      </div>

      <section id="content" class="description" v-if="!page.large_embed">
        <article v-html="page.content" class="a-underline owl"></article>
      </section>

      <section id="progress" v-if="showprogress">
        <figure class="thermometer" :class="{ 'goal-below': isProgressOverHalf }">
          <div :style="progress" class="progress"></div>
          <span
            :class="['progress-current', { 'inside-bar': isProgressOver80 }]"
            :style="isProgressOver80 ? {} : { left: `calc(${progress.width} + 8px)` }"
          >
            {{ page.progress.current }}
          </span>
          <div class="thermometer-max" v-if="!isProgressOverHalf">
            <span>{{ page.progress.max }}</span>
          </div>
        </figure>
        <div class="thermometer-max-below" v-if="isProgressOverHalf">
          <span>{{ page.progress.max }}</span>
        </div>
        <article v-html="page.progress.text"></article>
      </section>

      <!-- <section v-if="videoUrl" class="stream">
        <div class="embed">
          <iframe
            :src="videoUrl"
            allow="autoplay;encrypted-media"
            allowfullscreen
            webkitallowfullscreen
            mozallowfullscreen
            oallowfullscreen
            msallowfullscreen
          ></iframe>
        </div>
        <div v-html="onAir" class="on-air"></div>
      </section> -->

      <section id="content" class="description" v-if="page.large_embed">
        <article v-html="page.content" class="a-underline owl"></article>
      </section>

      <section v-if="page.donation_levels && page.tabs" class="levels">
        <form class="tabs">
          <div class="radio-group">
            <div v-for="(tab, key) in getTabs" class="radio-pill" :key="key">
              <input
                type="radio"
                :id="'tab-' + key"
                :value="key"
                name="tabs"
                v-model="active"
              />
              <label :for="'tab-' + key">{{ tab.title }}</label>
            </div>
          </div>
          <select class="pill" v-model="active">
            <option v-for="(tab, key) in getTabs" :value="key" :key="key">
              {{ tab.title }}
            </option>
          </select>
        </form>
        <div v-if="getActive" class="tab-totals pill-hover">
          <a v-if="getActive.link" :href="getActive.link" class="pill solid big"
            >Become a Member!</a
          >
        </div>
        <div v-if="getTabItems" class="tab-items row">
          <AboutThumb
            v-for="item in getTabItems"
            :item="item"
            template="row"
            :key="item.title"
          ></AboutThumb>
        </div>
      </section>
      <section
        v-else-if="!page.donation_levels && page.custom_items"
        class="levels"
      >
        <div v-if="page.custom_items_title" class="custom-items-title">
          <span class="">{{ page.custom_items_title }}</span>
        </div>
        <div class="custom-items row">
          <AboutThumb
            v-for="item in page.custom_items"
            :item="item"
            template="row"
            :key="item.title"
          ></AboutThumb>
        </div>
      </section>

      <section id="slideshow">
        <dublab-gallery
          v-if="page.slideshow"
          :images="page.slideshow"
          :extend="true"
        ></dublab-gallery>
      </section>

      <section id="support">
        <article>Other ways to support dublab</article>
        <div class="block-links">
          <vue-link
            v-for="item in page.support_summary"
            :to="item.link"
            class="block-link"
            :key="item.link"
          >
            <h2 class="a-hover underline">{{ item.title }}</h2>
            <br /><br />
            <p v-html="item.text"></p>
          </vue-link>
        </div>
      </section>

      <section>
        <article class="a-underline" v-html="page.footer"></article>
      </section>

      <section class="bottom-image-section">
        <img
          src="../assets/images/website_bottom_image.png"
          alt="Bottom Image"
          class="bottom-image"
        />
      </section>

      <div id="more" class="more">
        <div><h3 class="underline">Affiliate Stations</h3></div>
        <div class="flags">
          <a href="http://dublab.de/"
            ><img src="~@/assets/images/flag_de.svg"
          /></a>
          <a href="http://dublab.jp/"
            ><img src="~@/assets/images/flag_jp.svg"
          /></a>
          <a href="http://dublab.es/"
            ><img src="~@/assets/images/flag_es.svg"
          /></a>
          <a href="https://dublab.com.br/"
            ><img src="~@/assets/images/flag_br.svg"
          /></a>
        </div>

        <div><h3 class="underline">Social</h3></div>
        <div v-if="site" class="link-list">
          <div v-for="link in site.social_links" class="comma" :key="link.url">
            <a :href="link.url">{{ link.text }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="background" ref="background">
      <img src="../assets/images/dub_backg.png" />
    </div> -->
    <div class="background" ref="background">
      <img src="../assets/images/background_v3.png" />
    </div>
  </div>
</template>

<script>
import delve from "dlv";
import widont from "widont";
import dayjs from "dayjs";
// import loop from 'raf-loop'
import { mixin } from "@/lib/content-state";

import DublabGallery from "@/components/DublabGallery";
// import WavingText from "@/components/WavingText";
import AboutThumb from "@/components/AboutThumb";
import VueLink from "@/components/VueLink.js";

// let engine = null

export default {
  name: "Drive",
  mixins: [mixin],
  //removed component WavingText
  components: { AboutThumb, DublabGallery, VueLink },
  data() {
    return {
      translateY: 0,
      active: null,
    };
  },
  computed: {
    showprogress() {
      return (
        this.page.progress && this.page.progress.min && this.page.progress.max
      );
    },
    progress() {
      if (this.page.progress) {
        let max = this.page.progress.max;
        let current = this.page.progress.current;
        let max_val = parseInt(max.replace(/[^\d]+/g, ""));
        let current_val = parseInt(current.replace(/[^\d]+/g, ""));
        let width = (current_val / max_val) * 100;
        return { width: width + "%" };
      } else {
        return 0;
      }
    },
    isProgressOverHalf() {
      if (this.page.progress) {
        let max = this.page.progress.max;
        let current = this.page.progress.current;
        let max_val = parseInt(max.replace(/[^\d]+/g, ""));
        let current_val = parseInt(current.replace(/[^\d]+/g, ""));
        let percentage = (current_val / max_val) * 100;
        return percentage > 50;
      }
      return false;
    },
    isProgressOver80() {
      if (this.page.progress) {
        let max = this.page.progress.max;
        let current = this.page.progress.current;
        let max_val = parseInt(max.replace(/[^\d]+/g, ""));
        let current_val = parseInt(current.replace(/[^\d]+/g, ""));
        let percentage = (current_val / max_val) * 100;
        return percentage > 80;
      }
      return false;
    },
    videoUrl() {
      if (this.site && this.site.livevideo) {
        let url = this.site.livevideo.url;
        // turn off autoplay
        /* url = url
          .replace('autoplay=1', 'autoplay=0')
          .replace('autoplay=true', 'autoplay=false') */
        return url;
      } else return null;
    },
    playing() {
      return this.$store.state.audio.playing;
    },
    onAir() {
      return this.formatShow(this.playing.on_air, "On Air");
    },
    getTabs() {
      return delve(this.page, "tabs.options");
    },
    getTabItems() {
      if (delve(this.page, "tabs.entries")) {
        return this.page.tabs.entries.filter((item) => {
          return item.level.indexOf(this.active) >= 0;
        });
      } else return null;
    },
    getActive() {
      if (delve(this.page, "tabs.options")) {
        // reset active to first tab if necessary
        const keys = Object.keys(this.page.tabs.options);
        if (keys.indexOf(this.active) < 0) this.resetActive(keys);

        // return active tab
        return this.page.tabs.options[this.active];
      } else return null;
    },
  },
  methods: {
    resetActive(keys) {
      this.active = keys[0];
    },
    formatUnixTime(timestamp) {
      if (!timestamp) return "";
      let time = dayjs(new Date(timestamp * 1000))
        .format("h:mm a")
        .replace("am", "a.m.")
        .replace("pm", "p.m.");
      return time;
    },
    formatShow(show, label) {
      if (show.combo && show.start && show.end) {
        const title = show.combo;
        let start = this.formatUnixTime(show.start);
        let end = this.formatUnixTime(show.end);
        return `${label}<br><span>${start}</span> <span>to ${end}</span><br>${widont(
          title
        )}`;
      } else return "";
    },
    linearTransform(a1, b1, a2, b2, v) {
      return ((v - a1) / (b1 - a1)) * (b2 - a2) + a2;
    },
    translateBackground() {
      let min = 0;
      let max = document.body.clientHeight;
      let value = this.linearTransform(min, max, 0, 100, window.scrollY);
      if (this.translateY !== value) {
        this.translateY = value;
      }
      this.translateY = window.scrollY;
    },
  },
  mounted() {
    // engine = loop(this.translateBackground).start()
    // window.addEventListener('scroll', this.translateBackground)
  },
  beforeDestroy() {
    // engine.stop()
    // window.removeEventListener('scroll', this.translateBackground)
  },
};
</script>

<style>
#app.drive .Footer,
#app.drive .Footer * {
  color: #000 !important;
}
</style>

<style scoped>
@font-face {
  font-family: "NewEdge666-RegularRounded";
  src: url("../assets/fonts/NewEdge666-RegularRounded.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "NewEdge666-SemiboldRounded";
  src: url("../assets/fonts/NewEdge666-SemiboldRounded.otf") format("opentype");
  font-weight: 600;
  font-style: normal;
}

.ViewDrive {
  font-family: "NewEdge666-RegularRounded", sans-serif;
}

.ViewDrive {
  width: 100%;
  color: #000;
  background-color: #e4ffea; /* Add this line */
}

.ViewDrive h1,
.ViewDrive h2,
.ViewDrive h3 {
  font-family: "NewEdge666-SemiboldRounded", sans-serif;
}

.ViewDrive article,
.ViewDrive .a-underline,
.ViewDrive .owl {
  font-family: "NewEdge666-RegularRounded", sans-serif;
}

.ViewDrive article h1,
.ViewDrive article h2,
.ViewDrive article h3 {
  font-family: "NewEdge666-SemiboldRounded", sans-serif;
}

.bottom-image-section {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 1rem 0;
  margin: 1rem 0; */
}

.bottom-image {
  max-width: 90vw;
  width: 50%;
  height: auto;
  object-fit: contain;
}

.header-image-wrapper {
  /* background-color: #e4ffea; */
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* Optional: add padding for breathing room */
  padding: 2rem 0;
  /* margin-bottom: 2rem;
  border-radius: 0px 0px 10px 10px; */
}

.header-image {
  max-width: 100vw; /* Responsive: never wider than viewport */
  width: 100%; /* Fills container if smaller */
  height: auto; /* Maintains aspect ratio */
  max-height: 430px; /* Prevents it from being too tall */
  object-fit: contain;
  /* Optional: add border-radius or box-shadow for style */
  border-radius: 10px;
}

.ViewDrive {
  width: 100%;
  color: #000;
}

.content {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  z-index: 1;
  color: black;
}

/* Target only the content from page.content */
.description article {
  font-family: "FormaDJR";
  font-size: 2.5rem;
  width: 80%;
  margin: 0 auto;
  margin-top: 1rem;
  margin-bottom: 2rem;
  line-height: 1.4;
  max-width: 1200px;
}

@media (max-width: 1000px) {
  .description article {
    width: 80%;
    font-size: 2rem;
  }
}

@media (max-width: 800px) {
  .description article {
    width: 100%;
    font-size: 1.8rem;
  }
}

.reward {
  font-family: "FormaDJR";
}

section {
  width: 100%;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: center;
}

section:not(:first-of-type) {
  margin-top: 5rem;
}

section > * + * {
  margin-top: 3rem;
}

.large-embed .stream + .description,
.large-embed .description + .levels {
  margin-top: 12rem;
}

.topImage {
  z-index: -1;
  position: absolute;
  top: 0;
  width: 100vw;
}

.background {
  /* padding: 4rem; */
  position: fixed;
  /*top: 12rem;*/
  top: 0;
  left: 0;
  width: 100%;
  z-index: 0;
  background-color: #e4ffea;
  /*background: linear-gradient(180deg, blue 10%,  #DCD7D1 60%,  purple 90%);*/
}

.background img {
  max-width: 100%; /* Image width should be constrained to fit within the viewport */
  max-height: 100%; /* Image height should be constrained to fit within the viewport */
  object-fit: contain; /* Ensure the image maintains its aspect ratio and fits within the viewport */
}

.wavetext {
  text-shadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
  font-family: "CCBiffBamBoom", sans-serifserif;
  font-weight: bold;
  color: black;
  text-align: center;
  margin-top: 7rem;
  margin-bottom: 3rem;
}

.wavetext >>> span {
  font-size: 6.5vw !important;
}

.thermometer {
  position: relative;
  height: 8rem;
  border-radius: 8rem;
  border: 1px solid #000;
  overflow: hidden;
  width: 78%;
  margin: 0 auto;

  /*background-color: var(--accent);*/
  /*background-color: #000; */
  background-color: black;
  box-shadow: 0px 0px 2rem 0px rgba(255, 255, 255, 1);
  animation: glow 2s linear infinite alternate;
}

.thermometer .progress {
  background: #ff6417;
  height: 100%;
  border-radius: 8rem 0 0 8rem;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  transition: width 0.3s;
}

.thermometer .progress-current {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  font-family: "NewEdge666-RegularRounded", sans-serif;
  font-size: 2rem;
  font-weight: 400;
  letter-spacing: 0.05em;
  z-index: 2;
  white-space: nowrap;
  pointer-events: none;
  transition: left 0.3s, right 0.3s;
  padding-left: 2rem;
}

.thermometer .progress-current.inside-bar {
  color: #000;
  padding-left: 0;
  padding-right: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

@media (max-width: 1000px) {
  .thermometer .progress-current {
    padding-left: 2rem;
  }
}

@media (max-width: 550px) {
  .thermometer .progress-current {
    padding-left: 1rem;
    font-size: 1.5rem;
  }
}

article + .thermometer {
  margin-top: 5rem;
}

.thermometer div {
  text-align: right;
  /*font: var(--large);*/
  line-height: 7.75rem;
  padding-left: 3rem;
  padding-right: 3rem;
}

.thermometer .progress span,
.thermometer > div > span {
  color: #fff !important;
}

.thermometer div:first-child {
  background-color: #ff6417;
  border-right: 1px solid #000;
  height: 100%;
  float: left;
  color: #000;

  /*background-image:
    repeating-linear-gradient(
      90deg,
      transparent,
      transparent 1rem,
      #fff 1rem,
      #d9edff 2rem
    );
  background-size: 200% 200%;
  animation: barberpole 10s linear infinite;*/
}

.thermometer div:last-child {
  float: right;
}

.thermometer-max-below {
  text-align: right;
  margin-top: 1rem;
  font-family: "NewEdge666-RegularRounded", sans-serif;
  font-size: 2rem;
  font-weight: 400;
  letter-spacing: 0.05em;
  color: #000;
  width: 78%;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 800px) {
  .thermometer-max-below {
    width: 100%;
    padding-right: 1.5rem;
  }
}

article {
  font-family: "FormaDJR";
  font-size: 3.6rem;
  width: 75%;
  margin: 0 auto;
  margin-top: 1rem;
}

article >>> .pill {
  vertical-align: middle;
}

#progress {
  margin-top: 1rem;
}

.block-links {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.block-link {
  background-color: #fff;
  border: var(--b1);
  border-radius: var(--br1);
  padding: var(--p2);
  color: #000;
  width: 25%;
  vertical-align: top;
  margin: 1rem;
}

.block-link h2 {
  display: inline-block;
  border-color: #000;
}

.stream {
  width: 40%;
}

.levels {
  width: 58%;
  text-align: left;
  position: relative;
}

.large-embed .stream {
  width: 65%;
}

.large-embed .levels {
  width: 65%;
}

.levels select {
  display: none;
}

.join-anchor {
  position: absolute;
  top: -10rem;
}

.row:not(:first-child) {
  margin-top: 2rem;
  padding-top: 2rem;
}

.tab-items.row {
  padding-top: 0;
}

.tab-totals {
  border-top: var(--b1d);
  margin-top: 2rem;
  padding-top: 2rem;
}

.tab-totals a {
  width: 100%;
}

.levels >>> .AboutThumb.row:not(:first-child) {
  border-top-style: dashed;
  border-top-color: #fff;
}

.custom-items-title {
  /*font: var(--large);*/
  text-transform: uppercase;
  text-align: center;
}

.custom-items >>> .AboutThumb.row {
  display: block;
  border-top: 1px dashed #fff;
  padding-top: 2rem;
}

.custom-items >>> .AboutThumb.row figure {
  pointer-events: none;
}

.embed {
  padding-top: 56.25%;
  position: relative;
}

.embed >>> iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  outline: none;
  border: none;
}

.on-air {
  margin-top: 3rem;
  font: var(--large);
  font-weight: bold;
  /*text-shadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;*/
}

.large-embed .on-air {
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  font: var(--medium);
}

.on-air >>> span {
  display: inline-block;
  white-space: nowrap;
}

.DublabGallery {
  margin-left: -2rem;
  margin-right: -2rem;
}

.more {
  text-align: center;
  margin-top: 5rem;
  margin-bottom: 6rem;
}

.more h3 {
  display: inline-block;
  margin-top: 2rem;
}

.more > * + * {
  margin-top: 2rem;
}

.flags > * {
  display: inline-block;
  height: auto;
  width: 5rem;
  height: 3.4rem;
  margin: 0 1rem;
}

.comma {
  display: inline;
}

.invert .radio-group input[type="radio"]:checked + label {
  background: #3aaaff;
  color: #000;
}
.radio-pill input[type="radio"]:checked + label {
  background: rgb(251, 251, 166);
}
@media (min-width: 1000px) and (max-width: 1360px) {
  .radio-pill label {
    font-size: 0.8em;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
  }
}

@media (max-width: 1280px) {
  .stream {
    width: 34%;
  }

  .levels {
    width: 62%;
  }

  .large-embed .stream {
    width: 75%;
  }

  .large-embed .levels {
    width: 75%;
  }

  .thermometer {
    width: 100%;
  }

  .block-link {
    width: calc(33% - 2rem);
  }
}

@media (max-width: 1000px) {
  /* .background {
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8rem 2rem 2rem 2rem;
    transform: translateY(0) !important;
  } */

  .background svg {
    width: 100%;
    /*filter: drop-shadow(0 0 0.5rem rgba(255,255,255,0.5));*/
  }

  .levels .radio-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .levels select {
    display: none;
  }
  .radio-pill label {
    font-size: 1.5rem;
    padding: 0.5rem 1rem;
  }

  .wavetext {
    margin-top: 4rem;
    /*margin-bottom: 3rem;*/
  }

  .wavetext >>> span {
    font-size: 12vw !important;
  }

  .wavetext >>> span.space {
    display: block;
  }

  article {
    width: 100%;
    font: var(--medium);
  }

  .block-link {
    width: 45%;
  }

  /*  section.join {
    justify-content: center;
    flex-wrap: wrap;
  }*/

  .stream {
    width: 75%;
  }

  .levels {
    width: 100%;
    margin-top: 7rem;
  }

  .large-embed .stream {
    width: 75%;
  }

  .large-embed .levels {
    width: 100%;
  }

  .thermometer div {
    font: var(--medium);
    line-height: 8rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .join-anchor {
    top: -2rem;
  }
}

@media (max-width: 800px) {
  .block-link {
    width: 100%;
    margin: 0 0 2rem 0;
  }

  .stream {
    width: 100%;
  }

  .large-embed .stream {
    width: 100%;
  }

  section:not(:first-of-type) {
    margin-top: 6rem;
  }

  .large-embed .stream + .description,
  .large-embed .description + .levels {
    margin-top: 8rem;
  }

  /* section.join {
    margin-top: 6rem;
  }*/

  .thermometer div {
    font-size: 1.25rem;
    font-family: var(--ffdub);
    line-height: 8rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .thermometer div span {
    display: inline-block;
    transform: rotate(-45deg);
  }
}

@keyframes scale {
  from {
    transform: scale(0.67);
  }
  to {
    transform: scale(0.9);
  }
}

@keyframes glow {
  from {
    box-shadow: 0px 0px 2rem 1rem rgba(255, 255, 255, 0.75);
  }
  to {
    box-shadow: 0px 0px 1rem 0.5rem rgba(255, 255, 255, 1);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(-360deg);
  }
}

@keyframes barberpole {
  100% {
    background-position: 100% 100%;
  }
}

@keyframes background-animation {
  from {
    transform: rotateZ(0) translateY(-37%);
  }
  to {
    transform: rotateZ(-360deg) translateY(-37%);
  }
}

@keyframes spin {
  from {
    transform: rotateY(0);
  }
  to {
    transform: rotateY(90deg);
  }
}

@keyframes cyclefill {
  0% {
    fill: #f05582;
  }
  33% {
    fill: #89b9e3;
  }
  66% {
    fill: #94c649;
  }
  100% {
    fill: #ffd200;
  }
}

@keyframes cyclestroke {
  0% {
    stroke: #fff;
  }
  12.5% {
    stroke: #f05582;
  }
  25% {
    stroke: #fff;
  }
  37.5% {
    stroke: #89b9e3;
  }
  50% {
    stroke: #fff;
  }
  62.5% {
    stroke: #94c649;
  }
  75% {
    stroke: #fff;
  }
  87.5% {
    stroke: #ffd200;
  }
  100% {
    stroke: #fff;
  }
}
</style>
